/*
  File name: helpers.js
    Program Description:
    - This file exports the values from the environment variables that are being
    used throughout the system without exposing sensitive data.
*/

export const baseUrl = process.env.VUE_APP_BASEURL || 'http://localhost:3001/webapi'
export const appUrl = process.env.VUE_APP_PREFIX || ''
export const socketUrl = process.env.VUE_APP_SOCKET || 'http://localhost:3002'
export const socketDomain = process.env.VUE_APP_SOCKET_ROUTE || '/socket.io'
